/** French URL path segments used across the app. */
export const AppPaths = {
  connecting: 'connecting',
  connexion: 'connexion',
  etudiant: 'etudiant',
  formateur: 'formateur',
  admin: 'admin',
  createurContenu: 'createur-contenu',
  vieScolaire: 'vie-scolaire',
  pedagogie: 'pedagogie',
  ateliers: 'ateliers',
  tableauDeBord: 'tableau-de-bord',
  quiz: 'quiz',
  parcours: 'parcours',
  formationsInternes: 'formations-internes',
  mesFormations: 'mes-formations',
  ressources: 'ressources',
  projets: 'projets',
  satisfaction: 'satisfaction',
  apprenants: 'apprenants',
  inscriptions: 'inscriptions',
  maFormation: 'ma-formation',
  acces: 'acces',
  groupes: 'groupes',
  soumissions: 'soumissions'
} as const;

export const AppUrls = {
  connecting: `/${AppPaths.connecting}`,
  connexion: `/${AppPaths.connexion}`,
  connexionAdmin: `/${AppPaths.connexion}/${AppPaths.admin}`,
  etudiant: `/${AppPaths.etudiant}`,
  formateur: `/${AppPaths.formateur}`,
  admin: `/${AppPaths.admin}`,
  createurContenu: `/${AppPaths.createurContenu}`,
  vieScolaire: `/${AppPaths.vieScolaire}`,
  pedagogie: `/${AppPaths.pedagogie}`,
  vieScolaireApprenants: `/${AppPaths.vieScolaire}/${AppPaths.apprenants}`,
  vieScolaireSatisfaction: `/${AppPaths.vieScolaire}/${AppPaths.satisfaction}`,
  pedagogieApprenants: `/${AppPaths.pedagogie}/${AppPaths.apprenants}`,
  pedagogieInscriptions: `/${AppPaths.pedagogie}/${AppPaths.inscriptions}`,
  pedagogieAcces: `/${AppPaths.pedagogie}/${AppPaths.acces}`,
  pedagogieSatisfaction: `/${AppPaths.pedagogie}/${AppPaths.satisfaction}`,
  etudiantMaFormation: `/${AppPaths.etudiant}/${AppPaths.maFormation}`,
  createurDashboard: `/${AppPaths.createurContenu}/${AppPaths.tableauDeBord}`,
  createurParcours: `/${AppPaths.createurContenu}/${AppPaths.parcours}`,
  createurFormationsInternes: `/${AppPaths.createurContenu}/${AppPaths.formationsInternes}`,
  mesFormations: `/${AppPaths.mesFormations}`,
  createurRessources: `/${AppPaths.createurContenu}/${AppPaths.ressources}`,
  createurQuiz: `/${AppPaths.createurContenu}/${AppPaths.quiz}`,
  createurProjets: `/${AppPaths.createurContenu}/${AppPaths.projets}`,
  createurSatisfaction: `/${AppPaths.createurContenu}/${AppPaths.satisfaction}`,
  adminParcours: `/${AppPaths.admin}/${AppPaths.parcours}`,
  adminFormationsInternes: `/${AppPaths.admin}/${AppPaths.formationsInternes}`,
  adminRessources: `/${AppPaths.admin}/${AppPaths.ressources}`,
  adminQuiz: `/${AppPaths.admin}/${AppPaths.quiz}`,
  adminProjets: `/${AppPaths.admin}/${AppPaths.projets}`,
  adminSatisfaction: `/${AppPaths.admin}/${AppPaths.satisfaction}`,
  adminApprenants: `/${AppPaths.admin}/${AppPaths.apprenants}`,
  adminApprenantsNouveau: `/${AppPaths.admin}/${AppPaths.apprenants}/nouveau`,
  adminApprenant: (id: string) => `/${AppPaths.admin}/${AppPaths.apprenants}/${id}`,
  adminApprenantModifier: (id: string) =>
    `/${AppPaths.admin}/${AppPaths.apprenants}/${id}/modifier`,
  adminInscriptions: `/${AppPaths.admin}/${AppPaths.inscriptions}`,
  adminInscriptionFormation: (id: string) =>
    `/${AppPaths.admin}/${AppPaths.inscriptions}/${id}`,
  adminInscriptionBulkAssign: (id: string) =>
    `/${AppPaths.admin}/${AppPaths.inscriptions}/${id}/affecter`,
  adminAcces: `/${AppPaths.admin}/${AppPaths.acces}`,
  formateurGroupes: `/${AppPaths.formateur}/${AppPaths.groupes}`,
  formateurApprenants: `/${AppPaths.formateur}/${AppPaths.apprenants}`,
  formateurAteliers: `/${AppPaths.formateur}/${AppPaths.ateliers}`,
  formateurSatisfaction: `/${AppPaths.formateur}/${AppPaths.satisfaction}`,
  formateurGroupe: (groupeId: string) =>
    `/${AppPaths.formateur}/${AppPaths.groupes}/${groupeId}`,
  formateurApprenant: (id: string) => `/${AppPaths.formateur}/${AppPaths.apprenants}/${id}`,
  formateurQuizAttempt: (apprenantId: string, attemptId: string) =>
    `/${AppPaths.formateur}/${AppPaths.apprenants}/${apprenantId}/${AppPaths.quiz}/${attemptId}`,
  formateurSoumission: (id: string) => `/${AppPaths.formateur}/${AppPaths.soumissions}/${id}`
} as const;
